import { useEffect } from 'react'

import { useDomain } from '@tribeplatform/react-components/common'
import { useAuthToken } from '@tribeplatform/react-sdk/hooks'
import { CookieCategory, RoleType } from '@tribeplatform/react-sdk/types'

import { ProtectedConfigs } from '../../../configs/protected.js'

import { isEnterprise } from './utils.js'

export const useMsClarity = () => {
  const { domain, subfolder } = useDomain()
  const {
    data: { member, network },
  } = useAuthToken()
  const roleType = member?.role?.type
  const isPrivileged =
    roleType === RoleType.admin || roleType === RoleType.moderator
  const enabled =
    ProtectedConfigs.CLARITY_ENABLED &&
    isPrivileged &&
    !isEnterprise(network?.id)

  useEffect(() => {
    if (!enabled) {
      return
    }

    window.BM.scriptManager.register({
      name: 'clarity',
      consentCategory: CookieCategory.Analytics,
      load: () => {
        if (!window.clarity) {
          const script = document.createElement('script')
          script.innerHTML = `
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "kqgae44w37");
          `
          document.head.appendChild(script)
          return
        }

        if (window.clarity) {
          window.clarity('consent')
          window.clarity('start')
        }
      },
      unload: () => {
        if (window.clarity) {
          window.clarity('consent', false)
          window.clarity('stop')
        }
      },
      getCookiesToRemove: () => {
        const getCookieAttributes = () => {
          try {
            const domainParts = domain.split('.')
            // Microsoft clarity sets cookies on the highest domain level.
            const domainToRemove = `${domainParts.slice(-2).join('.')}`

            return {
              domain: domainToRemove,
              path: subfolder || '/',
            }
          } catch {
            return {
              domain: window.location.hostname,
              path: subfolder || '/',
            }
          }
        }
        const attributes = getCookieAttributes()

        return [
          {
            name: '_clck',
            options: {
              ...attributes,
            },
          },
          {
            name: '_clsk',
            options: {
              ...attributes,
            },
          },
        ]
      },
    })
  }, [domain, enabled, subfolder])
}
